/** Логотип: фиолетовый квадрат с белым курсором (из прототипа). */
export function Logo({ size = 36 }: { size?: number }) {
  return (
    <svg aria-hidden="true" width={size} height={size} viewBox="0 0 60 60">
      <rect x="3" y="3" width="54" height="54" rx="16" fill="#9466FF" stroke="#0A0716" strokeWidth="3" />
      <path
        d="M22 15 L44 35 L34.5 36.5 L39.5 46.5 L34.5 49 L29.5 39 L22 45 Z"
        fill="#FFFFFF"
        stroke="#0A0716"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path d="M9 22 H16 M11.5 10.5 L16.5 15.5" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
